import React from 'react';
import cn from 'classnames';
import { FaCheck } from 'react-icons/fa';
import Field from '../Field';
import styles from '../card.module.css';

/* Вкладка «Главная»: поля пятью группами (п. 5 ТЗ).
   Числа штатной и списочной численности приходят с сервера готовыми, на клиенте
   не считаются. Значения — текст, не поля ввода. */

// Признак: отмеченный квадрат, кликом не переключается — это вывод значения,
// а не флажок формы, поэтому span, а не input[type=checkbox].
const Mark = ({ on, children }) => (
  <div className={styles.chk}>
    <span className={cn(styles.chkBox, { [styles.chkOn]: on })}>
      {on && <FaCheck size={11} color="#fff" />}
    </span>
    {children}
  </div>
);

const Main = ({ data }) => (
  <div className={styles.pane}>
    <div className={styles.group}>Основные сведения</div>
    <div className={styles.fform}>
      <Field label="Тип" value={data.type} />
      <Field label="Статус" value={data.status} />
      <Field label="Сокращение" value={data.shortname} />
      <Field label="Полное название кафедры" value={data.name} wide />
      <Field label="Название для отчетов (в родительном падеже)" value={data.report_name} wide />
    </div>

    <div className={styles.group}>Руководство и подчинённость</div>
    <div className={styles.fform}>
      <Field label="Руководитель" value={data.director} />
      <Field label="Вышестоящий руководитель" value={data.parent_director} />
      <Field label="Вышестоящее подразделение" value={data.parent_name} wide />
    </div>

    <div className={styles.group}>Коды и размещение</div>
    <div className={styles.fform}>
      <Field label="Код подразделения" value={data.code} mono />
      <Field label="Код подчиненности" value={data.parental_code} mono />
      <Field label="Размещение на объекте УМБ" value={data.tfo} />
    </div>

    <div className={styles.group}>Штатная численность</div>
    <div className={styles.fform}>
      <Field label="Количество по штату, всего" value={data.staff_total} mono />
      <Field label="в т.ч. военнослужащие (В/С)" value={data.staff_military} mono />
      <Field label="в т.ч. гражданский персонал (Г/П)" value={data.staff_civil} mono />
      <Field label="Количество по списку, всего" value={data.list_total} mono />
      <Field label="в т.ч. военнослужащие (В/С)" value={data.list_military} mono />
      <Field label="в т.ч. гражданский персонал (Г/П)" value={data.list_civil} mono />
    </div>

    <div className={styles.group}>Признаки</div>
    <div>
      <Mark on={data.is_common}>Общеакадемическая</Mark>
      <Mark on={data.exclude_from_structure}>Не учитывать в структуре вуза</Mark>
      <Mark on={data.include_in_umk}>
        Включать в перечень Электронно-методического кабинета
      </Mark>
      <Mark on={data.include_in_individual_plans}>
        Включать в перечень Индивидуальных планов работ преподавателей
      </Mark>
    </div>
  </div>
);

export default Main;
